/* eslint-disable @typescript-eslint/no-explicit-any */
import { AppstoreOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
  ToolOutlined,
  UnorderedListOutlined,
  WarningOutlined } from '@ant-design/icons';
import { Button, Divider, Modal, Row, Space } from 'antd';
import React, { useState } from 'react';
import { shallowEqual, useDispatch } from 'react-redux';

import { useTranslation } from 'react-i18next';
import { ENV_TYPE } from '../../../../env.json';
import { updateOcrTrainingData } from '../../../../services/ML/trainingData/ocrTd';
import { useTypedSelector } from '../../../../store';
import { evidListToggled, ocrStepUpdated } from '../../../../store/impOcr';

const ImpOcrEvidBar = () => {

  const { t } = useTranslation();

  const userExists = useTypedSelector(state =>
    state.user.isNonAnonymousUserLoggedIn);

  const [isModalVisible, setModalVisible] = useState(false);

  const { isListVisible, step, ocrData } = useTypedSelector(state =>
    state.impOcr, shallowEqual);

  const dispatch = useDispatch();

  const onShowList = () =>
    !isListVisible ? dispatch(evidListToggled()) : null;

  const onShowCards = () =>
    isListVisible ? dispatch(evidListToggled()) : null;

  const onFinish = () => {
    dispatch(ocrStepUpdated(2));

  };

  const onOk = () => {
    setModalVisible(false);
    dispatch(ocrStepUpdated(0));
  };

  const sendData = () =>
    updateOcrTrainingData({
      dispatch,
      userExists,
      ocrData,
    });

  if (step !== 1) return null;

  return (
    <>
      <div style={{ width: '100%' }}>
        <Row
          justify='space-between'
          align='middle'
        >
          <Button
            type="dashed"
            icon={<ArrowLeftOutlined />}
            onClick={() =>
              setModalVisible(true)}
          />

          <Space>
            {ENV_TYPE === 'DEVELOPMENT' ? (
              <>
                <Button
                  type="primary"
                  onClick={sendData}
                  icon={<ToolOutlined />}
                />
                <Divider type='vertical' />
              </>
            ) : null}
            <Divider type='vertical' />
            <Button
              key="1"
              icon={<AppstoreOutlined />}
              type="dashed"
              color={isListVisible ? undefined : 'blue'}
              onClick={onShowCards}
            />
            <Button
              key="2"
              icon={<UnorderedListOutlined />}
              type="dashed"
              color={isListVisible ? 'blue' : undefined}
              onClick={onShowList}
            />
            <Divider type='vertical' />
            <Button
              type="primary"
              icon={<ArrowRightOutlined />}
              onClick={onFinish}
            />
          </Space>
        </Row>
      </div>
      <Modal
        visible={isModalVisible}
        title={(
          <>
            <WarningOutlined />
            {' '}
            {t('ImpOcrEvidBar.title')}
          </>
)}
        onOk={onOk}
        onCancel={() =>
          setModalVisible(false)}
      >
        {t('ImpOcrEvidBar.desc1')}
        {' '}
        <strong>{t('ImpOcrEvidBar.desc2')}</strong>
        {t('ImpOcrEvidBar.desc3')}
      </Modal>
    </>
  );
};

export default ImpOcrEvidBar;